<template>
  <div>
    <modal name="cvform" height="auto">
      <cvform :name="name" />
    </modal>
    <section class="mobile_only career_top_banner cat_in_top_banner cover">
      <div class="container"></div>
      <div class="bn_corner"></div>
    </section>
    <section class="contact_page career_page no_banner_page clearfix">
      <div class="container">
        <div class="contact_main">
          <h1 class="cat_title">{{ page.title }}</h1>
          <div class="text" v-html="page.content"></div>
          <h2 class="title" v-if="page.acf.jobs">משרות פנויות:</h2>
          <div class="all_careers" v-if="page.acf.jobs">
            <div
              class="career_row toggleContainer"
              v-for="(job, index) in page.acf.jobs"
              :key="index"
            >
              <div class="career_top ease">
                <a href="javascript:void(0);" onclick="toggle(this)">
                  {{job.title}}
                  <span class="show_icon"></span>
                </a>
              </div>
              <div class="career_open toggleInner">
                <b v-if="job.info">תיאור משרה:</b>
                <br />
                <span v-html="job.info"></span>
                <br />

                <b>היקף משרה:</b>
                <br />
                {{job.part_time}}
                <div class="bt_green ease">
                  <a href="javascript:void(0);" @click.prevent="openCvModal(job.title)">שלח קו״ח</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contact_side career_side"></div>
    </section>
  </div>
</template>

<script>
import Cvform from "../components/Popups/CvForm";

export default {
  data() {
    return {
      title: "",
      content: "",
      name: ""
    };
  },
  created() {
    /*this.$ajax
        .get(
          homeUrl +
            "wp-json/wp/v2/pages?slug=" +
            encodeURI(this.$route.params.career)
        )
        .then(reponse => {
          this.title = reponse.data[0].title.rendered;
          this.content = reponse.data[0].content.rendered;
        });*/
  },
  computed: {
    root: function() {
      return this.$root;
    },
    page: function() {
      if (typeof wpData.pageData == "object") {
        return wpData.pageData;
      }
      return JSON.parse(wpData.pageData);
    }
  },
  methods: {
    openCvModal(jobTitle) {
      this.name = jobTitle;
      this.$modal.show("cvform");
    }
  },
  components: {
    Cvform
  }
};
</script>
